import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../helpers/AxiosHelper';
import { API_LONG_REQUEST_TIMEOUT_MS } from '../constants/AppConstants';

// Analytics endpoints used by the Messaging and Calls report pages. Results are cached
// per {from, to, tz} so flipping tabs or filters never refetches.
export const analyticsApiSlice = createApi({
  reducerPath: 'analyticsApi',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getMessageBreakdown: builder.query({
      query: ({ from, to, tz }) => ({
        url: '/analytics/messages/breakdown',
        method: 'get',
        params: { from, to, tz },
        timeout: API_LONG_REQUEST_TIMEOUT_MS,
      }),
    }),
    // Both call systems (rhinoVoip + RhinoCall) from the CallHourlyStats table.
    getCallBreakdown: builder.query({
      query: ({ from, to, tz }) => ({
        url: '/analytics/calls/breakdown',
        method: 'get',
        params: { from, to, tz },
        timeout: API_LONG_REQUEST_TIMEOUT_MS,
      }),
    }),
    getInboundContacts: builder.query({
      query: ({ from, to }) => ({ url: '/analytics/contacts', method: 'get', params: { from, to } }),
    }),
    getMessagesByGroup: builder.query({
      query: ({ from, to }) => ({ url: '/analytics/messages/byGroup', method: 'get', params: { from, to } }),
    }),
    // Current state, not range-bound: conversations assigned to each member right now.
    getOpenByMember: builder.query({
      query: () => ({ url: '/analytics/conversations/openByMember', method: 'get' }),
    }),
    getRemindersSummary: builder.query({
      query: ({ from, to }) => ({ url: '/analytics/reminders/summary', method: 'get', params: { from, to } }),
    }),
  }),
});

export const {
  useGetMessageBreakdownQuery,
  useGetCallBreakdownQuery,
  useGetInboundContactsQuery,
  useGetMessagesByGroupQuery,
  useGetRemindersSummaryQuery,
  useGetOpenByMemberQuery,
} = analyticsApiSlice;
